import service1 from '../assets/services/webdevelopement.jpg';
import service2 from '../assets/services/restful-api.jpg';
import service3 from '../assets/services/database.jpg';
import service4 from '../assets/services/single-page.jpg';
import service5 from '../assets/services/Authentication_vs_Authorization.png';
import service6 from '../assets/services/frontend.png';
import service7 from '../assets/services/nodejs.png';
import service8 from '../assets/services/git-github.png';
import service9 from '../assets/services/responsive.png';
import service10 from '../assets/services/ecommerce-integration.png';

export const servicesData = [
          {
                    id: 1,
                    image: service1,
                    title: "Web Development",
                    desc: "Showcase full-stack web development projects built using the MERN stack. Demonstrate your ability to design and implement interactive, responsive, and feature-rich web applications.",
          },
          {
                    id: 2,
                    image: service2,
                    title: "RESTful API Development",
                    desc: "Highlight your proficiency in creating RESTful APIs using Node.js and Express, allowing frontend applications to interact with backend services.",
          },
          {
                    id: 3,
                    image: service3,
                    title: "Database Design and Management",
                    desc: "Showcase projects that involve MongoDB database design, data modeling, and effective query optimization.",
          },
          {
                    id: 4,
                    image: service4,
                    title: "Single-Page Applications (SPAs)",
                    desc: "Present applications that utilize React to build dynamic and user-friendly single-page applications.",
          },
          {
                    id: 5,
                    image: service5,
                    title: "Authentication and Authorization",
                    desc: "Highlight your knowledge of implementing secure authentication and authorization mechanisms, such as OAuth, JWT (JSON Web Tokens).",
          },
          {
                    id: 6,
                    image: service6,
                    title: "Frontend and UI Development",
                    desc: "Showcase your skills in designing and building intuitive user interfaces with React, CSS, and frontend frameworks like Bootstrap or Material-UI.",
          },
          {
                    id: 7,
                    image: service7,
                    title: "Node.js Backend Development",
                    desc: "Demonstrate your expertise in building scalable and efficient server-side applications using Node.js and Express.js.",
          },
          {
                    id: 8,
                    image: service8,
                    title: "Version Control and Collaboration",
                    desc: "Showcase your use of version control systems like Git and demonstrate your ability to collaborate effectively with other developers using platforms like GitHub.",
          },
          {
                    id: 9,
                    image: service9,
                    title: "Responsive Design",
                    desc: "Show your expertise in building responsive applications that work seamlessly across different devices and screen sizes.",
          },
          {
                    id: 10,
                    image: service10,
                    title: "E-commerce Integration",
                    desc: "If applicable, demonstrate your skills in integrating e-commerce functionalities, such as payment gateways and shopping cart systems.",
          },
];